import React, { useEffect, useState } from 'react'
import { Navigate, Redirect, useHistory } from 'react-router-dom'

import { ExpressServerRoot } from '../constants'

function WelcomeConnectContainer(props) {
  const [updatedAt, setUpdatedAt] = useState(props.me.updatedAt)
  const [showAndroid13Instructions, setShowAndroid13Instructions] = useState(false)
  const history = useHistory()

  useEffect(() => {
    document.addEventListener('visibilitychange', onDocumentVisible)
    return () => {
      document.removeEventListener('visibilitychange', onDocumentVisible)
    }
  }, [])

  const onSkip = async () => {
    history.push('/mobile/welcome/notifications')
  }

  const onDocumentVisible = () => {
    if (document.visibilityState === 'visible') {
      props.onRefresh()
    }
  }
  const fetchDataFromMobile = () => {
    if (!window.bridge) {
      alert('This feature requires the mobile app.')
      return
    }
    
    if (window.bridge.connectGoogleHealth) {
      window.healthConnectCallback = (result) => {
        if (result.success) {
          props.onSave({
            fitnessService: 'google-health',
          })
          history.push('/mobile/welcome/notifications')
        } else {
          alert(result.error || 'Failed to connect to Google Health Connect.')
        }
      }
      window.bridge.connectGoogleHealth(`${props.me.id}`)
    } else if (window.bridge.authorizeAndStartPhoneHealthDataCollection) {
      if (!window.bridge.isHealthDataAvailable) {
        alert('Connecting an Apple Watch requires the latest version of the EL-FIT iOS app.')
        return
      }
      window.bridge.isHealthDataAvailable((available) => {
        if (!available) {
          alert('Apple HealthKit is not available on this iOS device. Please setup the Health app and try again.')
          return
        }
        window.bridge.authorizeAndStartPhoneHealthDataCollection(`${props.me.id}`, (success) => {
          if (!success) {
            alert(
              "To use Apple Health from your phone, you need to approve this app's access to your health data. To approve access, visit Settings > Privacy > Health > EL-FIT"
            )
            return
          }
          props.onSave({
            fitnessService: 'apple-health',
          })
          history.push('/mobile/welcome/notifications')
        })
      })
    } else {
      alert('Tracking steps directly from the phone requires the latest version of EL-FIT mobile app.')
    }
  }
  const onEnableAppleHealth = () => {
    if (!window.bridge.isHealthDataAvailable) {
      alert('Connecting an Apple Watch requires the latest version of the EL-FIT iOS app.')
      return
    }
    window.bridge.isHealthDataAvailable((available) => {
      if (!available) {
        alert(
          'Apple HealthKit is not available on this iOS device. Please setup the Health app and connect your Apple Watch and try again.'
        )
        return
      }
      window.bridge.authorizeAndStartHealthDataCollection(`${props.me.id}`, (success) => {
        if (!success) {
          alert(
            "To use Apple Health, you need to approve this app's access to your health data. To approve access, visit Settings > Privacy > Health > EL-FIT"
          )
          return
        }
        props.onSave({
          fitnessService: 'apple-health',
        })
        history.push('/mobile/welcome/notifications')
      })
    })
  }
  return (
    <div className="screen welcome">
      {props.me.updatedAt !== updatedAt && <Redirect to="/mobile/welcome/notifications" />}
      <div className="navigation-bar">
        <div className="title">Connect Fitness Tracker</div>
      </div>
      <div className="content-flex">
        <div style={{ flex: 1 }} />
        <img
          style={{ margin: 'auto', width: 169, height: 256 }}
          src={require('../images/fitbit.png')}
          alt="poster"
        />
        <div style={{ flex: 1 }} />
        <p style={{ textAlign: 'center' }}>
          Use the instructions that came with your physical activity tracker to install the FitBit
          app, create a FitBit account and pair your fitness tracker.
        </p>
        <div style={{ flex: 1.8 }} />
        <a href={`${ExpressServerRoot}/fitbit/connect`} style={{ textDecoration: 'none' }}>
          <button className="black block">Link FitBit Account</button>
        </a>
        {(!window.bridge ||
          !window.bridge.getPlatform ||
          window.bridge.getPlatform() !== 'android') && (
          <a onClick={onEnableAppleHealth} style={{ textDecoration: 'none', marginTop: 18 }}>
            <button className="black block">Link Apple Watch</button>
          </a>
        )}
        <a onClick={fetchDataFromMobile} style={{ textDecoration: 'none', marginTop: 18 }}>
          <button className="black block">Track steps from my phone</button>
        </a>
        {(window.bridge && window.bridge.getPlatform && window.bridge.getPlatform() === 'android' && window.bridge.getAndroidApiLevel && window.bridge.getAndroidApiLevel() < 34) && (
          <div style={{ textAlign: 'center', marginTop: 10, color: '#666', fontSize: 13 }}>
            <p style={{ margin: '4px 0' }}>Using Android 13 or older?</p>
            <a onClick={() => setShowAndroid13Instructions(true)} style={{ textDecoration: 'underline', cursor: 'pointer', color: '#007AFF' }}>
              View Setup Instructions
            </a>
          </div>
        )}
        <a className="skip" onClick={onSkip}>
          Skip this Step
        </a>
      </div>
      {showAndroid13Instructions && (
        <div style={{
          position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, 
          backgroundColor: 'rgba(0,0,0,0.8)', zIndex: 9999,
          display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20
        }}>
          <div style={{
            backgroundColor: 'white', borderRadius: 12, padding: 24, maxWidth: 400, width: '100%',
            boxShadow: '0 4px 20px rgba(0,0,0,0.3)'
          }}>
            <h3 style={{ marginTop: 0, marginBottom: 16 }}>Health Connect Setup</h3>
            <p style={{ fontSize: 14, color: '#444', marginBottom: 16 }}>
              On Android 13 and older devices, you must link a source app to Health Connect.
            </p>
            <ol style={{ fontSize: 14, color: '#444', paddingLeft: 20, marginBottom: 24, lineHeight: 1.5 }}>
              <li style={{ marginBottom: 8 }}>Install <b>Health Connect</b> from the Play Store.</li>
              <li style={{ marginBottom: 8 }}>Install a step tracking app like <b>Google Fit</b> or <b>Samsung Health</b>.</li>
              <li style={{ marginBottom: 8 }}>Open Health Connect and allow your tracking app to <b>write Step data</b>.</li>
              <li>Return to EL-FIT and click <b>"Track steps from my phone"</b>.</li>
            </ol>
            <button 
              className="black block" 
              onClick={() => setShowAndroid13Instructions(false)}
              style={{ margin: 0 }}
            >
              Got It
            </button>
          </div>
        </div>
      )}
    </div>
  )
}

export default WelcomeConnectContainer
